import "./PhoneInput.scss";
import NumberFormat from "react-number-format";
import { useEffect, useState } from "react";
import { UnitedStates } from "../../../util/countries";
import { Input } from "antd";
import PhoneIcon from "../../icons/PhoneIcon";

export interface PhoneInputProps {
  country?: string;
  showAddon?: boolean;
  tabIndex?: number;
  value: string;
  onChange: (phone: string) => void;
}

export default function PhoneInput({
  country,
  value,
  tabIndex,
  showAddon,
  onChange,
}: PhoneInputProps) {
  const [phone, setPhone] = useState(value);

  useEffect(() => {
    setPhone(value);
  }, [value]);

  function handleRef(ev: HTMLInputElement) {
    if (ev) {
      ev.onblur = () => {
        onChange(ev.value);
      };
    }
  }
  const addon = <PhoneIcon />;
  return (
    <>
      {country === UnitedStates && (
        <div className={"phone-input-container"}>
          {showAddon && (
            <Input
              addonBefore={addon}
              size="large"
              placeholder={"(555) 555-5555"}
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              onBlur={(ev) => onChange(ev.target.value)}
            />
          )}
          <NumberFormat
            tabIndex={tabIndex}
            className={`phone-input ant-input ant-input-lg ${
              showAddon ? "input-with-addon" : ""
            }`}
            format={"(###) ###-####"}
            mask=""
            getInputRef={handleRef}
            value={phone}
            placeholder={"(555) 555-5555"}
            onValueChange={(values) => {
              const { value } = values;
              setPhone(value);
            }}
          />
        </div>
      )}

      {country !== UnitedStates && (
        <Input
          addonBefore={showAddon ? addon : null}
          tabIndex={tabIndex}
          size="large"
          placeholder={"(555) 555-5555"}
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          onBlur={(ev) => onChange(ev.target.value)}
        />
      )}
    </>
  );
}
